// updated 23. feb. 2023, fixed wrong birthday/age for corporate ssid (ssn)
// added appendix 'árs' / 'ára'

export function cleanSsn(ssn, grownUp = 18) {

  const kt = clean(ssn); // Remove all but numeric letters
  if (kt.length > 10) return { error: true, ssn: false }

  if (kt.length === 10) {  // now we check parity and values
    let _day = parseInt(kt.substring(0, 2))
    const day = _day < 32 ? _day : _day - 40;
    // const day = parseInt(kt.substring(0, 2))
    const month = parseInt(kt.substring(2, 4));
    if (month > 12) {
      return { error: true, ssn: false }
    }
    const serial = parseInt(kt.substring(6, 8));
    if (serial < 20) {
      return { error: true, ssn: false }
    }
    const century = parseInt(kt.substring(9, 10));
    if (century !== 9 && century !== 0) {
      return { error: true, ssn: false }
    }
    const year = century === 9
      ? `19${kt.substring(4, 6)}`
      : `20${kt.substring(4, 6)}`

    let sum = 0;
    sum += (3 * parseInt(kt.substring(0, 1)));
    sum += (2 * parseInt(kt.substring(1, 2)));
    sum += (7 * parseInt(kt.substring(2, 3)));
    sum += (6 * parseInt(kt.substring(3, 4)));
    sum += (5 * parseInt(kt.substring(4, 5)));
    sum += (4 * parseInt(kt.substring(5, 6)));
    sum += (3 * parseInt(kt.substring(6, 7)));
    sum += (2 * parseInt(kt.substring(7, 8)));

    let rem = sum % 11;
    if (rem === 0) rem = 11;

    if (11 - rem === parseInt(kt.substring(8, 9))) {
      // we have passed the parity check but still must check some values

      const ktDate = new Date()
      const now = new Date();
      const yearNow = now.getFullYear()
      const monthNow = now.getMonth() + 1
      const dayNow = now.getDate()

      ktDate.setFullYear(year)
      ktDate.setMonth(month - 1)
      // ktDate.setDate(parseInt(kt.substring(0, 2)))
      ktDate.setDate(day);
      const birthday = ktDate.toLocaleDateString()
      const birthdayNow = (dayNow === day && monthNow === month) ? true : false
      const ageThisYear = (yearNow - year)

      const preBirthday = ((monthNow < month) || (monthNow === month && dayNow < day)) ? 1 : 0
      const ageNow = ageThisYear - preBirthday
      const minor = ageNow < grownUp ? true : false;
      const appendix = (ageNow.toString().slice(-1) === "1" && ageNow !== 11) ? 'árs' : 'ára';
      if (ageNow >= 0 && ageNow < 100) {
        return { ssn: kt, error: false, birthdayNow: birthdayNow, birthDay: birthday, ageNow: ageNow, ageThisYear: ageThisYear, appendix: appendix, minor: minor }
      }
      return { error: true, ssn: false }
    }
    return { error: true, ssn: false }
  }
  return { error: false, ssn: false }
}

function clean(n) {
  let k;
  let j;
  let m = "";
  n = n.toString(); // breytum í string
  k = n.split("");  // strengur í array
  for (j = 0; j < n.length; j++) {
    if (k[j] * 1 > 0 || k[j] === '0') {
      // ef sætið er númer þá bætum því við m rununa
      m += k[j];
    }
  }
  return m;
}
